import React from "react"
import {
  footerSocialLinks,
  footerSocialItem,
} from "./social-medias.module.scss"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import PropTypes from "prop-types"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import { FooterSocialItem } from "./social-medias-styled"

const SocialMedias = ({ iconSize }) => {
  const buildInfos = useBuildData().site_settings
  const tabIcon = {
    facebook: buildInfos.facebook_url,
    instagram: buildInfos.instagram_url,
    twitter: buildInfos.twitter_url,
    youtube: buildInfos.youtube_url,
    linkedin2: buildInfos.linkedin_url,
  }
  return (
    <ul className={footerSocialLinks}>
      {Object.keys(tabIcon).map((socialIconName) => (
        <React.Fragment key={socialIconName}>
          {tabIcon[socialIconName] && (
            <FooterSocialItem className={footerSocialItem}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={tabIcon[socialIconName]}
                aria-label={`Suivez nous sur ${socialIconName}`}
              >
                <Icon size={iconSize} icon={socialIconName} />
              </a>
            </FooterSocialItem>
          )}
        </React.Fragment>
      ))}
    </ul>
  )
}
//-----------------------Prop-Types---------------------------//

SocialMedias.propTypes = {
  iconSize: PropTypes.number,
}
SocialMedias.defaultProps = {
  iconSize: 20,
}
//-----------------------Prop-Types---------------------------//

export default SocialMedias
